/**
 * Decides which resource is assigned to at least one class - regardless which one.
 * @param {string} subjectId - The ID of the master subject.
 * @param {object} resourcesState - The object where we keep the state of the resources.
 * @param {array} items - The list of items we are interested in.
 * @returns {array} The received items update with assigned state (assigned or not).
 * */
export const updateItemsWithAssignedState = (
  subjectId,
  resourcesState,
  items,
) =>
  items.reduce((acc, item) => {
    const key = `resource-${item.resourceId}-subject-${subjectId}`;
    const resourceState = resourcesState[key] || {};

    acc.push({
      ...item,
      alreadyAssigned: (resourceState.savedClasses || []).length > 0,
    });

    return acc;
  }, []);
